__turbopack_context__.v({
  "marquee": "vVRc8W_marquee",
  "marqueeAnim": "vVRc8W_marqueeAnim",
  "marqueeContent": "vVRc8W_marqueeContent",
  "marqueeItem": "vVRc8W_marqueeItem",
  "root": "vVRc8W_root",
});
